/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimeGrid/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import FullCalendarTimegrid from './FullCalendarTimegrid/react'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TimeGrid({
  children,
  viewPath = "/DesignSystem/TimeGrid",
  isSubmitting
  
}) {
let timegridIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'timegrid',
})
let timegridResourcesValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'resources',
})
let timegridEventsValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'events',
})
let timegridDateValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'date',
})
let timegridSlotIntervalValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_interval',
})
let timegridLocationValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'location',
})
let timegridSlotMinTimeValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_min_time',
})
let timegridSlotMaxTimeValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_max_time',
})
let timegridFocusedEventIdValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'focused_event_id',
})
let timegridSchedulingConfigValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'scheduling_config',
})
let timegridHipaaValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'hipaa',
})
let timegridResourceWidthValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'resource_width',
})
let timegridHasAppointmentTemplateFiltersValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'has_appointment_template_filters',
})
let timegridAppointmentTypeCandidatesValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'appointment_type_candidates',
})
let timegridAppointmentQueueValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'appointment_queue',
})
  return (<React.Fragment
>
<fromFlow.When is={timegridIsSubmittingData}>
<div
  data-testid="TimeGrid.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 height={60}
 width={60}
 delay={1000}
/>
</div>
</fromFlow.When>
<FullCalendarTimegrid
  viewPath={`${viewPath}/FullCalendarTimegrid`}
 data="timegrid.resources"
 resources={timegridResourcesValueData}
 data="timegrid.events"
 events={timegridEventsValueData}
 data="timegrid.date"
 date={timegridDateValueData}
 data="timegrid.slot_interval"
 slotInterval={timegridSlotIntervalValueData}
 data="timegrid.location"
 location={timegridLocationValueData}
 data="timegrid.slot_min_time"
 slotMinTime={timegridSlotMinTimeValueData}
 data="timegrid.slot_max_time"
 slotMaxTime={timegridSlotMaxTimeValueData}
 data="timegrid.focused_event_id"
 focusedEventId={timegridFocusedEventIdValueData}
 data="timegrid.scheduling_config"
 schedulingConfig={timegridSchedulingConfigValueData}
 data="timegrid.hipaa"
 hipaa={timegridHipaaValueData}
 data="timegrid.resource_width"
 resourceWidth={timegridResourceWidthValueData}
 data="timegrid.has_appointment_template_filters"
 hasAppointmentTemplateFilters={timegridHasAppointmentTemplateFiltersValueData}
 data="timegrid.appointment_type_candidates"
 appointmentTypeCandidates={timegridAppointmentTypeCandidatesValueData}
 data="timegrid.appointment_queue"
 appointmentQueue={timegridAppointmentQueueValueData}
/>
{children}
</React.Fragment>)
}